import { Injectable } from '@angular/core';

@Injectable()
export class Global {

     userToken: string = null;
     User: any = [];
     CanWrite = false;
     IsLoaderOn = true;
     auditTrailId: string;
     auditTrailClass: string;
     RecoveryID:string;
     WaiveOffStatusID = false;
     RolesList: any;
     IsAdmin = false;
     IsLocationSPOC = false;
     IsFinance = false;
     IsOfficeHead = false;
     IsQBROwner = false;
     IsUser = false;
     loading = false;
     CurrentRole: string;
     IsBulkLoad=false;
     EmailPattern =
          '^[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]{3}|[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+.[a-zA-Z0-9]{2}$';
     IsAuditVisible = false;
     CurrentYear: Number = new Date().getFullYear();
     pageIndex = 1;
     length = 0;
     totalPage = 0;
     RecordSize = 10;
     IsConsent: boolean;
     SecondaryHeadBtnVisible = false;
     //excelPath = 'https://ingurrmpapptst1.mea.ey.net:20169/INPMC.WebAPI/Content/UploadAsset.xlsx';
     excelPath='assets/FileSample/EmployeeRecovery.xlsx';
     privacyPath = 'https://ingurrmpapptst1.mea.ey.net:20169/INPMC.WebAPI/Content/PrivacyNotice.docx';
     ShowAlert(msg: string) {
          alert(msg);
     }
}
